// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.search-button').on('click', function() {
    setTimeout(function() {
      jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });
  
  /* start-boost-custom */
  //#110227
  InstantSearchResultItemCollection.prototype.compileTemplate = function() {
		if (!this.isShow) {
			return '';
		}
		this.searchTerm = Utils.stripHtml(Globals.currentTerm);
		var searchLink = Utils.reBuildUrlBaseOnLocale('/collections/' + this.data.handle);
		var highlightedSuggestionResult = this._highlightSuggestionResult(this.data.title, this.searchTerm);
		
    	var collectionTitle = Utils.stripHtml(this.data.title);
    	var newCollectionTitle = '';
        if(collectionTitle.indexOf('|') !== -1){
          newCollectionTitle = collectionTitle.split('|')[1];
        }else{
        	if(collectionTitle.indexOf('_') !== -1){
              newCollectionTitle = collectionTitle.split('_')[1];
            }else{
            	newCollectionTitle = collectionTitle;
            }
        }
    	return this.getTemplate()
			.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
			.replace(/{{escapedDataTitle}}/g, newCollectionTitle)
			.replace(/{{escapedDataId}}/g, Utils.stripHtml(this.data.id))
			.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
			.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
			.replace(/{{searchLink}}/g, searchLink)
			.replace(/{{highlightedSuggestionResult}}/g, newCollectionTitle);
	};
  
  	InstantSearchResultItemCollection.prototype.render = function() {
		if (this.data) {
			this.$element = jQ(this.compileTemplate());
			// Set item data for ui-autocomplete-item
          	var collectionTitle = Utils.stripHtml(this.data.title);
            var newCollectionTitle = '';
            if(collectionTitle.indexOf('|') !== -1){
              newCollectionTitle = collectionTitle.split('|')[1];
            }else{
                if(collectionTitle.indexOf('_') !== -1){
                  newCollectionTitle = collectionTitle.split('_')[1];
                }else{
                    newCollectionTitle = collectionTitle;
                }
            }
			this.$element.attr('data-title', newCollectionTitle);
		} else {
			this.$element = null;
		}
		
	}
  //End #110227
  /* end-boost-custom */

    InstantSearchMobile.prototype.bindEvents = function() {
		this.$searchInput = jQ(this.selector.searchInput);
		this.$clearButtonElement = jQ(this.selector.clearButton);
		this.$closebuttonElement = jQ(this.selector.closebutton);
		this.$submitButtonElement = jQ(this.selector.submitButton);
		this.$topPanelElement = jQ(this.selector.topPanel);
		this.$overlayElement = jQ(this.selector.overlay);
		
		// apply autocomplete for search input
		this.searchBox = new SearchInput(this.inputMobileId, this.$searchInput);
		this.searchBox.refresh();

		// Add close button event
		this.$closebuttonElement.on('click', this.closeInstantSearchMobile.bind(this, true));
		// Add clear button event
		this.$clearButtonElement.on('click', this.clearInstantSearchMobile.bind(this));

		this.$searchInputs = jQ(this.selector.searchInputs + ':not([data-disable-instant-search])');
		this.$searchInputs
			.on('click', this._onClickSearchBox.bind(this))
			.on('focus', this._onFocusSearchBox.bind(this))
			.on('keyup', this._onTypeSearchBoxEvent.bind(this));
		this.$searchInput.on('focus', this._onFocusMobileInput.bind(this));
		this.$targetInput = null;

		this.isBoundEvents = true;
	}

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
        const customPriceHtml = `
          <div class="pfs-custom-suggestion-price">
            <div class="suggestion-price">
              {{price}}
            </div>
          </div>
        `;
        const customPriceSaleHtml = `
          <div class="card__priceblock pfs-custom-suggestion-price-sale">
            <span class="compare-at-price">{{priceMinSale}} - {{priceMaxSale}}</span><br/>
            <span class="price sale-price">{{priceMinOriginal}} - {{priceMaxOriginal}}</span>
          </div>
        `;

        const customPriceSaleHtmlSingleVariant = `
        <div class="card__priceblock pfs-custom-suggestion-price-sale">
          <span class="compare-at-price">{{priceMaxSale}}</span>
          <span class="price sale-price">{{priceMaxOriginal}}</span>
        </div>
      `;
    
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Check price varies
        var priceVaries = this.data.price_min != this.data.price_max;
		// Format price
        const getPrice = (price) => {
          var price = Utils.formatMoney(price);
    			if (Settings.getSettingValue('search.removePriceDecimal')) {
    				price = Utils.removeDecimal(price);
    			}
          return price;
        };

    
		// Build Price
        
		var result = '';
		if (!Settings.getSettingValue('search.showSuggestionProductPrice')) return result;
    
    if (domainContains('seatosummit.eu')) {
      var activeCurrency = Shopify.currency.active.toLowerCase();
      var price_min = this.data['price_min_' + activeCurrency] ? this.data['price_min_' + activeCurrency] : this.data.price_min;
      var price_max = this.data['price_max_' + activeCurrency] ? this.data['price_max_' + activeCurrency] : this.data.price_max;
      var compare_at_price_min = this.data['compare_at_price_min_' + activeCurrency] ? this.data['compare_at_price_min_' + activeCurrency] : this.data.compare_at_price_min;
      var compare_at_price_max = this.data['compare_at_price_max_' + activeCurrency] ? this.data['compare_at_price_max_' + activeCurrency] : this.data.compare_at_price_max;
    }

    if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice') && priceVaries) {
				result = customPriceSaleHtml;
        if (domainContains('seatosummit.eu')) {
          return result
          .replace('{{priceMaxOriginal}}', getPrice(price_max))
          .replace('{{priceMaxSale}}', getPrice(compare_at_price_max))
          .replace('{{priceMinOriginal}}', getPrice(price_min))
          .replace('{{priceMinSale}}', getPrice(compare_at_price_min))
        } else {
          return result
          .replace('{{priceMaxOriginal}}', getPrice(this.data.price_max))
          .replace('{{priceMaxSale}}', getPrice(this.data.compare_at_price_max))
          .replace('{{priceMinOriginal}}', getPrice(this.data.price_min))
          .replace('{{priceMinSale}}', getPrice(this.data.compare_at_price_min))
        }
                
		}  else if (onSale && !priceVaries) {
        result = customPriceSaleHtmlSingleVariant
        if (domainContains('seatosummit.eu')) {
          return result
          .replace('{{priceMaxOriginal}}', getPrice(price_max))
          .replace('{{priceMaxSale}}', getPrice(compare_at_price_max))
        } else {
          return result
          .replace('{{priceMaxOriginal}}', getPrice(this.data.price_max))
          .replace('{{priceMaxSale}}', getPrice(this.data.compare_at_price_max))
        }
    } else {
				result = customPriceHtml; 
        if (domainContains('seatosummit.eu')) {
          return priceVaries ? result
          .replace('{{price}}', `${getPrice(price_min)} - ${getPrice(price_max)}`)
          : result
          .replace('{{price}}', getPrice(price_min))
        } else {
          return priceVaries ? result
          .replace('{{price}}', `${getPrice(this.data.price_min)} - ${getPrice(this.data.price_max)}`)
          : result
          .replace('{{price}}', getPrice(this.data.price_min))
        }
			}
	}
  if (domainContains('seatosummit.eu')) {
    InstantSearchApi.beforeCall = function(searchTerm) {
      if (Shopify.country == 'NO') {
          Globals.instantSearchQueryParams.h_options = ['exclude_no'];
          Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
          Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
          Globals.instantSearchQueryParams.return_all_currency_fields = false;
      }
    }
  }

})();

function domainContains(string) {
  return window.location.hostname.includes(string);
}